import React, { forwardRef } from "react";
import DOMPurify from "dompurify";
import type { Config } from "dompurify";

export interface SanitizedProps {
    content: string;
    component?: React.ElementType<any>;
    dompurifyConfig?: Config;
}

export type SanitizedComponentProps<T = HTMLElement> = SanitizedProps & React.HTMLAttributes<T>;

export const Sanitized = forwardRef<HTMLElement, SanitizedComponentProps<HTMLElement>>(
    ({ content, component = "div", dompurifyConfig, ...rest }, ref) => {
        return React.createElement(component, {
            ...rest,
            ref,
            dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(content, dompurifyConfig) },
        });
    }
);

export default Sanitized;
